var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"auth-title"},[_vm._v("请使用公司内网或链接VPN后访问。")])])
}]

export { render, staticRenderFns }